<div class="modal-header">
    <h4 class="modal-title">{{titleText}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onNegativeClick()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    {{bodyText}}
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="onNegativeClick()">{{negativeText}}</button>
    <button type="button" class="btn btn-outline-dark" (click)="onAffirmativeClick()">{{affirmativeText}}</button>
</div>